export default __webpack_public_path__ + "static/lframe-contact-us-d62b71745dbe1da170edfddd17baaa25.png";